import { faAlignLeft } from '@fortawesome/pro-solid-svg-icons/faAlignLeft';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const PIA = ({
  dataLinkId,
  isActive,
  setActive,
}: {
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const notesLink = `${styles.LinkRight} ${styles.NotesLink} ${
    isActive ? styles.Active : ''
  }`;

  const iconClass = `${styles.Icon} ${isActive ? styles.Active : ''}`;

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faAlignLeft}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={notesLink}
      copy="PIA"
      onClick={onClick}
    />
  );
};

export default PIA;
